import { useCryptoConversion } from '../../hooks'
import { useConversionScopedStore } from '../../../../store/scoped'
import { EstimatedTransactionFee } from '../EstimatedTransactionFee'

import { BaseView } from '@/components/base'
import {
  AvailableAmountInWalletTextButton,
  RowItem,
} from '@/components/composites'
import { currencyUtils } from '@/utils/currency'

const { convertBetweenCurrencies, removeTrailingZeros } = currencyUtils

export const ConversionInfos = () => {
  const { handleInputChange } = useCryptoConversion()

  const fromCurrencyInfoWallet = useConversionScopedStore(
    (state) => state.conversion.from.currencyInfoInWallet,
  )
  const toCurrencyInfoWallet = useConversionScopedStore(
    (state) => state.conversion.to.currencyInfoInWallet,
  )

  const debitWalletInfos = fromCurrencyInfoWallet
  const debitCurrencyCode = debitWalletInfos?.displayCurrencyCode
  const debitPricePerUnit = debitWalletInfos?.pricePerUnit

  const creditWalletInfos = toCurrencyInfoWallet
  const creditCurrencyCode = creditWalletInfos?.displayCurrencyCode
  const creditPricePerUnit = creditWalletInfos?.pricePerUnit
  const creditRate = convertBetweenCurrencies({
    amount: 1,
    rateFromCurrency: Number(debitPricePerUnit),
    rateToCurrency: Number(creditPricePerUnit),
    toCurrency: creditWalletInfos?.code,
  })

  return (
    <BaseView style={{ gap: '16px' }}>
      <AvailableAmountInWalletTextButton
        cryptoCode={debitWalletInfos.code}
        onPress={({ amountWithoutNumberConversion }) =>
          handleInputChange({
            type: 'from',
            value: amountWithoutNumberConversion,
          })
        }
      />

      <BaseView style={{ gap: '10px' }}>
        {/* Ex: Pricing: 1 USDT = 0.00000956 BTC */}
        <RowItem
          label="transactions:rowItemLabels.pricing"
          value={`1 ${debitCurrencyCode} = ${removeTrailingZeros(creditRate)} ${creditCurrencyCode}`}
        />
        <EstimatedTransactionFee />
      </BaseView>
    </BaseView>
  )
}
